module.exports = __webpack_public_path__ + "static/media/DT-LOGO-Reverse-2022.944d9cc5.png";